import { Check } from "lucide-react";
import { MEDIA } from "@/data/media";
import { PRIVATES } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const PrivatesSection = ({ onInquire }) => {
  return (
    <section
      id="privates"
      data-testid="privates-section"
      className="section"
      style={{ backgroundColor: "var(--bg)" }}
    >
      <div className="container-fx">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <Reveal className="order-2 lg:order-1">
            <div
              className="relative overflow-hidden"
              style={{
                borderRadius: "var(--radius-lg)",
                border: "1px solid var(--border-c)",
                aspectRatio: "4 / 5",
              }}
            >
              <img
                src={MEDIA.privatesImage}
                alt="Private training"
                className="h-full w-full object-cover"
                loading="lazy"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(to top, rgba(11,10,8,0.55), rgba(11,10,8,0.05))",
                }}
              />
            </div>
          </Reveal>

          <Reveal delay={0.12} className="order-1 lg:order-2">
            <div>
              <p className="eyebrow">{PRIVATES.eyebrow}</p>
              <h2
                className="display mt-5"
                style={{ fontSize: "clamp(2.2rem, 5vw, 3.6rem)", fontWeight: 500 }}
              >
                {PRIVATES.headline_lead}{" "}
                <span className="accent-italic">{PRIVATES.headline_accent}</span>
              </h2>
              <p
                className="mt-6 max-w-xl"
                style={{
                  color: "var(--text-2)",
                  fontSize: "1rem",
                  lineHeight: 1.7,
                }}
              >
                {PRIVATES.body}
              </p>
              <ul className="mt-6 space-y-3">
                {PRIVATES.points.map((p) => (
                  <li
                    key={p}
                    className="flex items-start gap-3"
                    style={{ color: "var(--text-2)", fontSize: "0.94rem" }}
                  >
                    <Check
                      size={16}
                      style={{ color: "var(--bronze)", marginTop: 3, flexShrink: 0 }}
                    />
                    {p}
                  </li>
                ))}
              </ul>
              <button
                data-testid="privates-inquire-button"
                onClick={onInquire}
                className="btn-fx btn-primary mt-9"
              >
                Inquire About Privates
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
